import type { CompoundFilter, KeyValueFilter } from './typeUtils';

export type FilteringParams = {
	path: string;
	value: string;
	operator?: 'EQ' | 'NEQ' | 'CONTAINS';
}[];

export const buildCompoundFilter = (
	filtering?: FilteringParams,
	search?: string,
	searchableFields: string[] = [],
): CompoundFilter | undefined => {
	const equalFilters: KeyValueFilter[] =
		filtering?.map((f) => ({
			key: f.path,
			operator: f.operator ?? 'EQ',
			value: f.value === 'null' ? null : f.value,
		})) || [];

	const containsFilters: KeyValueFilter[] = search
		? searchableFields.map((field) => ({
				key: field,
				operator: 'CONTAINS',
				value: search,
			}))
		: [];

	let orFilters;
	if (containsFilters.length === 1) {
		orFilters = containsFilters[0];
	} else if (containsFilters.length > 1) {
		orFilters = { OR: containsFilters };
	}

	const andFilters: CompoundFilter[] = [];
	if (equalFilters.length === 1) {
		andFilters.push(equalFilters[0]);
	} else if (equalFilters.length > 1) {
		andFilters.push({ AND: equalFilters });
	}

	if (orFilters) {
		andFilters.push(orFilters);
	}

	if (andFilters.length === 0) {
		return;
	} else if (andFilters.length === 1) {
		return andFilters[0];
	} else {
		return { AND: andFilters };
	}
};
